/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
function ModuleDependencyTemplateAsRequireId() {}
module.exports = ModuleDependencyTemplateAsRequireId;

ModuleDependencyTemplateAsRequireId.prototype.apply = function(dep, source, outputOptions, requestShortener) {
	if(!dep.range) return;
	var comment = "";
	if(outputOptions.pathinfo) comment = "/*! " + requestShortener.shorten(dep.request) + " */ ";
	if(dep.module)
		var content = "__webpack_require__(" + comment + JSON.stringify(dep.module.id) + ")";
	else
		var content = require("./WebpackMissingModule").module(dep.request);
	source.replace(dep.range[0], dep.range[1] - 1, content);
};

ModuleDependencyTemplateAsRequireId.prototype.applyAsTemplateArgument = function(name, dep, source) {
	if(!dep.range) return;
	source.replace(dep.range[0], dep.range[1] - 1, "(__webpack_require__(" + name + "))");
};



//////////////////
// WEBPACK FOOTER
// (webpack)/lib/dependencies/ModuleDependencyTemplateAsRequireId.js
// module id = 1891
// module chunks = 0